import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-8ea25566"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "loadingCard is-loading"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "image group block w-full aspect-w-4 aspect-h-3 bg-gray-50 overflow-hidden" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]

import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { useTrackEvent } from "shared/composables/tracking";
import Sidebar from "@/components/layout/Sidebar.vue";
import LiveBase from "@/components/live_video/LiveBase.vue";
import LiveSwitch from "@/components/live_video/LiveSwitch.vue";
import CameraItemLayout from "@/views/camera/components/CameraItemLayout.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Live',
  setup(__props) {

const loading = ref(false);
const { params } = useRoute();

const trackEvent = useTrackEvent();

onMounted(() => {
  trackEvent("camera_live_view");
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Sidebar, null, {
      default: _withCtx(() => [
        _createVNode(CameraItemLayout, null, {
          contentLeft: _withCtx(() => [
            _createElementVNode("div", null, [
              (loading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
                : _createCommentVNode("", true)
            ]),
            (_unref(params)?.camera_id)
              ? (_openBlock(), _createBlock(LiveBase, {
                  key: 0,
                  cameraId: _unref(params)?.camera_id as string
                }, null, 8, ["cameraId"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(LiveSwitch, { class: "fixed lg:absolute live-container right-5 z-10" })
  ], 64))
}
}

})